import Model from '@/models/Model.js';

export default class CourseCodeEvaluationTemplate extends Model {
    static entity = 'course_code_evaluation_template';

    static modelName = 'CourseCodeEvaluationTemplate';

    static primaryKey = ['course_code_id', 'evaluation_template_id'];

    static fields() {
        return {
            id: this.attr(null),
            course_code_id: this.attr(null),
            evaluation_template_id: this.attr(null),

            ...super.fields(),

            course_code: this.belongsTo('course-codes', 'course_code_id'),
            evaluation_template: this.belongsTo('evaluation_templates', 'evaluation_template_id'),
        };
    }
}
